import { render } from "./Title.vue?vue&type=template&id=6b3cb561&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=6b3cb561&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3cb561"],['__file',"src/components/title/Title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b3cb561"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b3cb561', __exports__)) {
    console.log('reload')
    api.reload('6b3cb561', __exports__)
  }
  
  module.hot.accept("./Title.vue?vue&type=template&id=6b3cb561&scoped=true", () => {
    console.log('re-render')
    api.rerender('6b3cb561', render)
  })

}


export default __exports__